import { DropdownOption } from '../components/common/Dropdown';
import type { LocationItem } from '../types/selectUBT.types';
export const transformToDropdownOptions = (
  items: LocationItem[],
  includeCode = true
): DropdownOption[] => {
  return items.map((item) => ({
    id: item.code,
    label: includeCode ? `${item.code} ${item.name}` : item.name,
    value: item.code,
  }));
};

export const transformCostCenterOptions = (
  items: LocationItem[]
): DropdownOption[] => {
  return items.map((item) => ({
    id: `${item.code}-${item.name?.split(' ').join('-')}`,
    label: `${item.code} - ${item.name}`,
    value: item.code,
  }));
};

export const addDefaultOption = (
  options: DropdownOption[],
  defaultOpt: DropdownOption
): DropdownOption[] => {
  return [defaultOpt, ...options];
};
